import React, { Component } from 'react'
import { IContainerCustomization } from '../PartnerCustomizations'
import {
  UniKeyV1CredentialC,
  RawCredentialC,
  WiegandCredentialC,
  Corp1000CredentialC,
  TSBnFCredentialC,
  TSBwFCredentialC,
  ECredentialType,
  IPartnerCredImpls,
  StringCredentialC
} from '@unikey/unikey-commons/release/comm'

import { HnyUniKeyV1Credential } from './models/hnyU1Credential'

export default () => {

  const dealerSkinningOffered = false;
  
  const partnerCredImpls: IPartnerCredImpls = {
    PartnerSCred: StringCredentialC,
    PartnerRCred: RawCredentialC,
    PartnerWCred: WiegandCredentialC,
    PartnerU1Cred: HnyUniKeyV1Credential,
    PartnerC1000Cred: Corp1000CredentialC,
    Partner37BwFCred: TSBwFCredentialC,
    Partner37BnFCred: TSBnFCredentialC,
  };

  const partnerCredImplAvailability: ECredentialType[] = [
    ECredentialType.unikeyV1
  ];

  const CredentialCreate: IContainerCustomization = {
    props: {
      partnerCredImplAvailability,
      partnerCredImpls,
      partnerDefaultCredentialType: ECredentialType.unikeyV1,
      preventBulkUpload: false,
      partnerCsvExampleTemplate: (
        <>
          <p>EMAIL,FACILITY_CODE,CARD_NUMBER,TYPE</p>
          <p>address1@example.com,15,3555555555,UniKeyV1</p>
          <p>address2@example.com,15,2888888888,</p>
        </>
      )
    }
  }

  const CredentialList: IContainerCustomization = {
    props: {
      partnerCredImpls,
      partnerDefaultCredentialType: ECredentialType.unikeyV1,
      preventToggleUserInstaller: true
    }
  }

  const CredentialDetails: IContainerCustomization = {
    props: {
      partnerCredImpls,
      partnerDefaultCredentialType: ECredentialType.unikeyV1,
      preventToggleUserInstaller: true
    }
  }

  const DeviceList: IContainerCustomization = {
    props: {
      partnerCredImpls
    }
  }
  const DealerRegisterForm: IContainerCustomization = {
    props: {
      dealerSkinningOffered
    }
  }
  
  const DealerDetails: IContainerCustomization = {
    props: {
      dealerSkinningOffered
    }
  }

  const Portal: IContainerCustomization = {
    props: {
      dealerSkinningOffered
    }
  }

  const PortalPrereq: IContainerCustomization = {
    props: {
      dealerSkinningOffered
    }
  }

  return {
    Portal,
    PortalPrereq,
    CredentialCreate,
    CredentialList,
    CredentialDetails,
    DealerRegisterForm,
    DealerCreate: DealerRegisterForm,
    DeviceList,
    DealerDetails
  }
}
